import React from "react";

import classnames from "classnames";
import BoltIcon from "Intuit/BoltIcon";
import isIntuit from "Intuit/isIntuit";

import Icon from "Common/Icon";
import DottedBox from "Theme/DottedBox";

import makeBem from "Utils/makeBem";

const bem = makeBem("AddAncillaryPlanBox");

const AddAncillaryPlanBox = ({ title, onClick, disabled, className, ...props }) => (
  <DottedBox
    className={classnames(bem(), className, { [bem(null, "disabled")]: disabled }, { [bem(null, "intuit")]: isIntuit() })}
    disabled={disabled}
    onClick={onClick}
    {...props}
  >
    {isIntuit() ? <BoltIcon icon="create" mr={3} /> : <Icon icon="plus" flavor="solid" mr={3} />}

    <span>{title}</span>
  </DottedBox>
);

export default AddAncillaryPlanBox;
